module.exports = __webpack_public_path__ + "img/slide6-img-min.86b23a5d.webp";